<template>
  <div class="ui-alert" :class="[`ui-alert_${alert.type}`]">
    <div class="ui-alert__marker" />
    <div class="ui-alert__content">
      <div v-if="alert.loader" class="ui-alert__spinner">
        <Spinner />
      </div>
      <div class="ui-alert__body">
        <div v-if="alertText" class="ui-alert__text">
          {{ alertText }}
        </div>
        <div v-if="alert.primaryAction || alert.secondaryAction" class="ui-alert__actions">
          <Button
            v-if="alert.primaryAction && alert.primaryActionText"
            class="ui-alert__action-btn"
            size="small"
            @click="alert.primaryAction()"
          >
            {{ alert.primaryActionText }}
          </Button>
          <Button
            v-if="alert.secondaryAction && alert.secondaryActionText"
            class="ui-alert__action-btn"
            type="secondary"
            size="small"
            @click="alert.secondaryAction()"
          >
            {{ alert.secondaryActionText }}
          </Button>
        </div>
      </div>
    </div>
    <Button class="ui-alert__close-icon" type="func" icon="x" @click="close(alert.id)" />
  </div>
</template>

<script>
  import { mapActions } from 'vuex';
  import Spinner from 'vue-simple-spinner';
  import ALERT_TYPES from '@/utils/constants/alert-types';
  import Button from '@/components/ui-v2/Button';

  export default {
    name: 'AlertTooltip',
    components: {
      Button,
      Spinner,
    },
    props: {
      alert: {
        type: Object,
        required: true,
      },
    },
    computed: {
      alertText() {
        let alertComputedText = this.alert.text;
        if (!alertComputedText) {
          if (this.alert.type === ALERT_TYPES.ERROR) {
            alertComputedText = this.$t('An error has occurred');
          } else if (this.alert.type === ALERT_TYPES.SUCCESS) {
            alertComputedText = this.$t('Success');
          }
        }
        return alertComputedText;
      },
    },
    methods: {
      ...mapActions({
        close: 'alert/closeAlert',
      }),
    },
  };
</script>
